import { useQuery } from '@tanstack/react-query';
import { Geofence, GeofenceFilterInput } from '@models/geofence.model';
import { geofenceService } from '@services/geofence';

export const GEOFENCES_QUERY_KEY = ['geofences'];

export const useGeofences = (filter?: GeofenceFilterInput) => {
  return useQuery<Geofence[], Error>({
    queryKey: [...GEOFENCES_QUERY_KEY, filter ?? null],
    queryFn: async () => {
      const geofences = await geofenceService.getGeofences(filter);
      return geofences || [];
    },
    staleTime: 60 * 1000,
  });
};

export const useGeofence = (geofenceId: string | undefined) => {
  return useQuery<Geofence | null, Error>({
    queryKey: [...GEOFENCES_QUERY_KEY, 'single', geofenceId ?? null],
    queryFn: async () => {
      if (!geofenceId) return null;
      return await geofenceService.getGeofence(geofenceId);
    },
    enabled: !!geofenceId,
  });
};

export default useGeofences;
